<div class="flex gap-2 mt-3">
  <app-button type="primary" [disabled]="disabled()" (clickEvent)="onAllow()">Proceed</app-button>
  <app-button type="secondary" [disabled]="disabled()" (clickEvent)="onDeny()">Cancel</app-button>
</div>
